module.exports = __webpack_public_path__ + "img/whatsapp.dc74ce57.svg";